// The eleven follow-up actions a user can attach to an incoming fax (PD-1513).
// Mirrored into packages/web/src/model/middleware-types.ts — a change here MUST
// update that mirror in the same commit.
//
// Split out of fax-task-actions.ts so the create-fax-task contract (which the
// web bundle pulls in) can import this list without also pulling in
// faxTaskName's handler-only logic — the web/mw boundary plugin only allows
// *.contract.ts, *.schema.ts, and contracts.ts to cross into the web bundle.
export const FAX_TASK_ACTIONS = [
  { code: 'complete-form', label: 'Complete form' },
  { code: 'provider-review', label: 'Provider review' },
  { code: 'provider-signature', label: 'Provider signature' },
  { code: 'fax-document-back', label: 'Fax document back' },
  { code: 'contact-patient', label: 'Contact patient' },
  { code: 'contact-requesting-office', label: 'Contact requesting office' },
  { code: 'schedule-appointment', label: 'Schedule appointment' },
  { code: 'upload-document', label: 'Upload or attach document' },
  { code: 'review-results', label: 'Review results' },
  { code: 'request-information', label: 'Request additional information' },
  { code: 'other', label: 'Other' },
] as const

export type FaxTaskActionCode = (typeof FAX_TASK_ACTIONS)[number]['code']

export function isFaxTaskActionCode(value: string): value is FaxTaskActionCode {
  return FAX_TASK_ACTIONS.some((a) => a.code === value)
}
